import { __assign } from "tslib";
import { createHttpTestKit } from '../http/test-kit';
import { createFakePostResponder, createFakeGetResponder } from '../test-utils';
import { createAccountApi, PaymentCycleType } from './index';
export var createAccountApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createAccountApi('', fakeHttp);
    var testKit = {
        whenExtendSession: function (sameSite) {
            return createFakePostResponder(fakeHttp, '/accounts/extend-session')((sameSite === true) ? { sameSite: true } : {});
        },
        whenGetPurchaseData: createFakePostResponder(fakeHttp, '/billing/purchase'),
        whenGetCallCenterCreditBalance: function () { return createFakeGetResponder(fakeHttp, '/billing/callcenter/balance'); },
        whenGetPricingPlans: function () { return createFakeGetResponder(fakeHttp, 'https://www.wixanswers.com/api/pricing-plans'); },
        whenUpgrade: function () {
            return createFakePostResponder(fakeHttp, 'https://www.wixanswers.com/adminApi/notifier/upgrade')({ PaymentCycleType: PaymentCycleType });
        },
        whenPingRealTime: createFakePostResponder(fakeHttp, '/accounts/realtime/ping'),
        whenGetZuoraIframe: function (debug) {
            return createFakeGetResponder(fakeHttp, "/billing/iframe" + (debug ? "?debug=" + debug : ''));
        },
        whenConfirmZuoraOrder: createFakePostResponder(fakeHttp, '/billing/order'),
        whenPreviewZuoraOrder: createFakePostResponder(fakeHttp, '/billing/order/preview'),
        whenPurchaseCallCredits: createFakePostResponder(fakeHttp, '/billing/order/callCredits'),
        whenGetBillingProvider: function () { return createFakeGetResponder(fakeHttp, '/billing/provider'); },
        whenGetUserCountryCode: function () { return createFakeGetResponder(fakeHttp, '/users/me/geo/country'); },
        whenIsNameAvailable: function (name) { return createFakePostResponder(fakeHttp, '/tenants/nameAvailable')(name); },
        whenGetLatestInvoicesDetails: function () { return createFakeGetResponder(fakeHttp, '/billing/invoices'); },
        whenGetDefaultPaymentMethod: function () { return createFakeGetResponder(fakeHttp, '/billing/paymentMethods/default'); },
        whenReplaceDefaultPaymentMethod: function (dto) { return createFakePostResponder(fakeHttp, '/billing/creditCards/replace')(dto); }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map